import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, TS_CollapsableContainerV2, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend';
import { exists } from '@nu-art/ts-common';
import { Component_PrettyPrint_Expression } from '@app/hcs-frontend/ui-components';
import { ModuleFE_Expression, ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { ModuleFE_PathwayTransition } from '../../../../../../_entity.js';
import './Renderer_PathwayResolution.scss';
export class Renderer_PathwayResolution extends ComponentSync {
    // Read-only preview: re-read from cache on any expression change so deleting/editing an RF
    // (e.g. from the accordion) updates or clears this preview without needing a tab switch.
    __onExpressionUpdated = () => this.reDeriveState();
    deriveStateFromProps(nextProps, state) {
        state.transitionId = nextProps.transitionId;
        const transition = ModuleFE_PathwayTransition.cache.unique(state.transitionId);
        state.resolutionFunction = exists(transition?.resolutionFunctionId)
            ? ModuleFE_Expression.cache.unique(transition.resolutionFunctionId)
            : undefined;
        return state;
    }
    render() {
        const hasResolution = exists(this.state.resolutionFunction);
        if (!hasResolution && !this.props.showWhenEmpty)
            return null;
        return _jsx(TS_CollapsableContainerV2, { className: 'pathway-resolution', headerRenderer: () => 'Resolution', containerRenderer: hasResolution ? this.render_PrettyPrint : this.render_Empty, animated: true, forceUpdate: true });
    }
    render_Empty = () => _jsx("div", { className: 'pathway-resolution__empty', children: "No resolution function" });
    render_PrettyPrint = () => {
        // Pretty Print V2 (same renderer as the side panel's "Pretty Print V2" tab).
        // The renderer throws on unresolved value refs / malformed atoms (e.g. imported-preview data),
        // so degrade just the resolution preview instead of crashing the whole pathway tab.
        return _jsx(TS_ErrorBoundary, { renderer: this.render_PrettyPrintError, children: _jsx(Component_PrettyPrint_Expression, { expression: this.state.resolutionFunction, interactive: false, guidelines: true, modules: {
                    variable: ModuleFE_Variable,
                    value: ModuleFE_Value,
                    expression: ModuleFE_Expression,
                } }) });
    };
    render_PrettyPrintError = () => _jsx("div", { className: 'pathway-resolution__error', children: "Resolution function can't be previewed \u2014 it has unresolved references." });
}
//# sourceMappingURL=Renderer_PathwayResolution.js.map